export enum IProductBundleState {
  UNKNOW = 'unknow',
  NEW = 'new',
  TOKEN_CREATED = 'tokenCreated',
  APP_CREATED = 'appCreated',
}
